export const buildMarketingPageCanonicalHref = (
  slug: string,
  category?: string
) => ['https://streamable.com', category, slug].filter(Boolean).join('/');
